// Labels genéricas reutilizadas no app do viajante.

export const pt = {
  save: 'Salvar',
  cancel: 'Cancelar',
  back: 'Voltar',
  loading: 'Carregando…',
  retry: 'Tentar novamente',
  logout: 'Sair',
  language: 'Idioma',
  online: 'Online',
  offline: 'Offline',
  saveError: 'Não foi possível salvar',
};

export const es: typeof pt = {
  save: 'Guardar',
  cancel: 'Cancelar',
  back: 'Volver',
  loading: 'Cargando…',
  retry: 'Reintentar',
  logout: 'Salir',
  language: 'Idioma',
  online: 'En línea',
  offline: 'Sin conexión',
  saveError: 'No se pudo guardar',
};
